import { Injectable } from "@angular/core";
import { createAction, props } from '@ngrx/store'
import { CatalogueItem } from "../../models/catalogueItem.model";

export const addPharmacyCatalogueItems = createAction('Pharmacy Catalogue Items', props<CatalogueItem>())